import React from 'react'
import { Container } from '@sencha/ext-modern'
import { getLoginToken } from '../public/index'

const blankFn = () => { }
class TyanLims extends React.Component {
	componentDidMount() {
		const { _path } = this.props
		const iframe = document.getElementById('iframex')
		var doc = iframe.contentDocument || iframe.document
		doc.body.innerHTML = '数据加载中...'
		if (!_path) {
			Tyan.pubForm.showError('TyanLims菜单路径不存在！')
			return
		}
		iframe.src = Tyan.appSettings.tyanLimsBasePath + '?p=' + _path[1] + '&t=' + getLoginToken() + '&c=' + iframe.clientWidth + 'O' + iframe.clientHeight + 'O'

		addEventListener('message', this.eventMessage)
	}

	componentWillUnmount() {
		removeEventListener('message', this.eventMessage)
	}

	eventMessage = e => {
		const msgFns = {
			'logout': () => { location.hash = '/Logout' },
			'refresh': () => { Tyan.pubControl.lastPostEvent = Date.now() }
		}
		// e.data为子页面发送的数据
		true && (e.data && msgFns[e.data['msg']] || blankFn)()
	}

	render() {
		return <React.Fragment >
			<Container width={!Ext.os.is.Phone && 700} layout={{ type: 'vbox', pack: 'center', align: 'stretch' }}    >
				<Container autoSize defaults={{ flex: 1, shadow: true }} flex={2}
					layout={{ type: Ext.os.is.Phone ? 'vbox' : 'hbox', pack: 'center', align: 'stretch' }}>
					<iframe
						name='iframex'
						id="iframex"
						style={{ width: '100%', height: '100%', overflow: 'visible' }}
						width="100%"
						height="100%"
						scrolling="yes"
						frameBorder="0"
					/>
				</Container>
			</Container >
		</React.Fragment >
	}
}
export default TyanLims

